const cfg = (typeof window !== 'undefined' && window.SP_SITE) ? window.SP_SITE : {};

export const getSite = (key, fallback = '') => {
  const value = cfg[key];
  return value === undefined || value === null || value === '' ? fallback : value;
};

export const assetUrl = (path) => {
  const base = (cfg.assetBase || '').replace(/\/$/, '');
  const clean = String(path || '').replace(/^\//, '');
  return base ? `${base}/${clean}` : `/${clean}`;
};

export default cfg;
